const themeLight = {
  'primary': '#030303',
  'secondary': '#606060',
  'terciary': '#242424',
  'accent': '#FF023E',
  'bg_primary': '#FFFFFF',
  'bg_secondary': '#F9F9F9',
  'bg_terciary': '#F3F3F3'
};

const themeDark = {
  'primary': '#FFFFFF',
  'secondary': '#AAAAAA',
  'terciary': '#F9F9F9',
  'accent': themeLight.accent,
  'bg_primary': '#181818',
  'bg_secondary': '#202020',
  'bg_terciary': '#1c1c1c'
};

const themes = {
  'light': themeLight,
  'dark': themeDark
};

export default themes;
